import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useReorderEmojiMutation = createMutationHook(
  MembershipsCreatorApiClient.reorderEmoji,
  {
    mutationKey: ['reorderEmoji'],
  },
)
